import React from 'react';
import { SwitchRoute } from '../../../Components/Route/SwitchRoute';
import { LeadOwnerAdminAssignAgentRoutes  } from '../../../routes';

export const LeadOwnerAdminAssignAgentLayout = () => {
  return <SwitchRoute routes={LeadOwnerAdminAssignAgentRoutes} />;
};

